import { Grid, Button, Typography, TextField } from "@material-ui/core";
import { PrimaryButton } from "../components-atoms";
import GeneralModal from "./GeneralModal";
import { useEffect, useState } from "react";


interface SubscriptionPremiumFeeModalProps {
	classes: any;
	isVisible: boolean;
	isDisabled: boolean;
  defaultValue?: string | null;
	close: () => void;
	setPremiumFee: (pf: number) => void;
}

export function SubscriptionPremiumFeeModal({ defaultValue, classes, isVisible, isDisabled, close, setPremiumFee }: SubscriptionPremiumFeeModalProps): JSX.Element {
	const [pf, setPf] = useState<string>(defaultValue?.toString() || "0.0");

  useEffect(() => {
    if (defaultValue) {
      setPf(defaultValue?.toString());
    }
  }, [defaultValue]);

	function isFloat(val: string) {
		var floatRegex = /^[0-9]+(\.)?[0-9]*$/;
		if (!floatRegex.test(val)) return false;
		if (isNaN(parseFloat(val))) return false;
		return true;
	}
	const hasInvalidPrice = !isFloat(pf) || parseFloat(pf) <= 0.0;

	return (
		<GeneralModal
			title="Concierge fee"
			description="Update the concierge fee"
			modalWidth="560px"
			visible={isVisible}
			onClose={() => close()}
		>
			<GeneralModal.ContentArea>
				<Grid container style={{ marginTop: '16px' }}>
					<Grid item container spacing={2}>
						<Grid item xs={12}>
							<TextField
								fullWidth
								variant="outlined"
								margin="normal"
								id="PremiumFee"
								placeholder="Concierge fee"
								label="Concierge fee"
								name="CategoryName"
								value={pf}
								onChange={v => setPf(v.target.value)}
								error={hasInvalidPrice}
								disabled={isDisabled}
							/>
						</Grid>
					</Grid>
					{hasInvalidPrice && <Grid item xs={12}>
						<Typography variant="caption" color="error">
							Please enter a valid price.
						</Typography>
					</Grid>
					}
				</Grid>
			</GeneralModal.ContentArea>
			<GeneralModal.ButtonArea>
				<Button
					className={classes.cancelButton}
					onClick={() => close()}
					disabled={isDisabled}
				>
					<Typography
						variant="button"
						component="p"
						color="primary">
						Cancel
					</Typography>
				</Button>
				<PrimaryButton
					title="Save"
					onClick={() => { if (!hasInvalidPrice) setPremiumFee(parseFloat(pf)); }}
					style={{ marginLeft: '8px' }}
					disabled={isDisabled || hasInvalidPrice}
				/>
			</GeneralModal.ButtonArea>
		</GeneralModal>
	);
}
